function getViewportStateKey(...positions) {
  return [
    window.innerWidth,
    document.documentElement.clientHeight,
    ...positions.map(Math.round)
  ].join(":");
}
function getNaturalListHeight(list) {
  if (!list.style.maxHeight) {
    list._styleMaxHeight = parseFloat(getComputedStyle(list).maxHeight) || Infinity;
  }
  return Math.min(list.scrollHeight, list._styleMaxHeight ?? Infinity);
}
function setListCap(list, maxHeight) {
  var _a;
  const value = maxHeight === null ? "" : `${Math.max(maxHeight, 0)}px`;
  if (list.style.maxHeight === value) return false;
  list.style.maxHeight = value;
  (_a = list.refresh) == null ? void 0 : _a.call(list);
  return true;
}
function fitDropdownToViewport({ anchorTop, anchorBottom, naturalHeight, chrome, gap }) {
  const viewportHeight = document.documentElement.clientHeight;
  const below = viewportHeight - anchorBottom - gap * 2;
  const above = anchorTop - gap * 2;
  if (naturalHeight <= below) return { side: "bottom", listMax: null };
  if (naturalHeight <= above) return { side: "top", listMax: null };
  const side = above > below ? "top" : "bottom";
  return { side, listMax: Math.max((side === "top" ? above : below) - chrome, 0) };
}
export {
  fitDropdownToViewport,
  getNaturalListHeight,
  getViewportStateKey,
  setListCap
};
